"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNavigatorShare = void 0;
const tslib_1 = require("tslib");
const qs_1 = require("qs");
const react_1 = require("react");
/**
 * Wraps native `navigator.share` and adds an extra functionality. If method is
 * supported by browser, it will return wrapped method, otherwise `undefined`.
 * @typedef {object} Share
 * @property {Function|undefined} handleShare - Async function to be triggered, when method is supported by browser, otherwise `undefined`.
 * @property {string|undefined} shareUrl - share url for android, otherwise `undefined`
 * @param {object} params
 * @param {object} params.data Data to be passed to `navigator.share` as per https://developer.mozilla.org/en-US/docs/Web/API/Navigator/share
 * @param {Function} params.onShare Callback that will be called only when content was successfully shared.
 * @returns {Share}
 */
const useNavigatorShare = ({ data, onShare }) => {
    var _a;
    // Don't forget to add 'android_share_handler' into the array at
    // app/assets/javascripts/initializers/frontoffice.js:22
    // ex : window.AlumniConnect.mobile = window.mobile_option || ['people_directory_map'];
    const windowWithAlumniConnect = typeof window === 'undefined' ? null : window;
    const AlumniConnect = windowWithAlumniConnect === null || windowWithAlumniConnect === void 0 ? void 0 : windowWithAlumniConnect.AlumniConnect;
    const androidShare = (_a = AlumniConnect === null || AlumniConnect === void 0 ? void 0 : AlumniConnect.mobile) === null || _a === void 0 ? void 0 : _a.includes('android_share_handler');
    const canShare = (typeof window !== 'undefined' && Boolean(navigator.share)) || androidShare;
    const shareData = Object.assign(Object.assign({}, data), { text: (data === null || data === void 0 ? void 0 : data.text) ? `${data.text}\n` : data === null || data === void 0 ? void 0 : data.text });
    const shareUrl = androidShare
        ? `hbshare://share?${(0, qs_1.stringify)(shareData)}`
        : '';
    const navigatorShare = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        try {
            yield navigator.share(shareData);
            onShare === null || onShare === void 0 ? void 0 : onShare();
        }
        catch (_a) {
            // Do nothing if sharing was unsuccessful
        }
    });
    const handleShare = (0, react_1.useCallback)((event) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        if (!canShare) {
            return;
        }
        if (androidShare) {
            yield (onShare === null || onShare === void 0 ? void 0 : onShare());
            return;
        }
        event === null || event === void 0 ? void 0 : event.preventDefault();
        event === null || event === void 0 ? void 0 : event.stopPropagation();
        navigatorShare();
    }), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [data, onShare]);
    return { handleShare, shareUrl, canShare };
};
exports.useNavigatorShare = useNavigatorShare;
//# sourceMappingURL=index.js.map